export const AppStyles = {
  height: 'auto',
};

export const captionMenuMobile = {
  fontSize: '1.75rem',
  marginTop: '107px',
  fontWeight: '800',
};
